import { render, staticRenderFns } from "./CarteiraKanbanApp.vue?vue&type=template&id=2fd99b6b&scoped=true"
import script from "./CarteiraKanbanApp.vue?vue&type=script&lang=js"
export * from "./CarteiraKanbanApp.vue?vue&type=script&lang=js"
import style0 from "./CarteiraKanbanApp.vue?vue&type=style&index=0&id=2fd99b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd99b6b",
  null
  
)

export default component.exports